import { useState } from "react";

type SortOption = "name" | "popularity" | "date";

interface SortDropdownProps {
  onSortChange: (option: SortOption) => void;
}

export default function SortDropdown({ onSortChange }: SortDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<SortOption>("popularity");

  const options = [
    { value: "name", label: "Alphabetical" },
    { value: "popularity", label: "Most Popular" },
    { value: "date", label: "Newest First" }
  ];

  const handleOptionClick = (option: SortOption) => {
    setSelectedOption(option);
    onSortChange(option);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm hover:bg-gray-50"
      >
        <span>Sort by: {options.find(o => o.value === selectedOption)?.label}</span>
        <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg z-10">
          {options.map(option => (
            <button
              key={option.value}
              onClick={() => handleOptionClick(option.value as SortOption)}
              className={`block w-full text-left px-4 py-2 text-sm hover:bg-[#1E90FF] hover:text-white ${
                selectedOption === option.value ? "bg-gray-100" : ""
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}